import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as LeadConfigService from 'services/agents/config/leads';

export const useLeadConfigService = () => {
  const { token } = useSelector((store) => store.user_data);

  const upsertLeadConfig = async (data, options = {}) => {
    const { error, payload: lead } = await LeadConfigService.create({
      ...options,
      data,
      token
    });

    if (error) {
      toast.error('Cannot create lead config at this time');
      return { config: {} };
    }

    toast.success('Lead config created successfully.');
    return { config: lead };
  };

  const fetchLeadConfigs = async (options = {}) => {
    const { error, payload } = await LeadConfigService.read({ ...options, token });

    if (error) {
      toast.error(error);
      return { configs: [], size: 0 };
    }

    const {
      data: configs,
      meta: { size }
    } = payload;
    return { configs, size };
  };
  return { upsertLeadConfig, fetchLeadConfigs };
};
